"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.msalConfig = exports.loginRequestNoPrompt = exports.loginRequestDefault = void 0;
var _ApplicationContext = require("../ApplicationContext");
const msalConfig = () => {
  const azureRedirectUrl = `${window.location.protocol}//${window.location.hostname}${window.location.hostname === 'localhost' ? ':' + window.location.port : ''}`;
  const azureTenantId = _ApplicationContext.ApplicationContext.getAzureTenantId();
  return {
    auth: {
      clientId: _ApplicationContext.ApplicationContext.getAzureApplicationId(),
      authority: `https://login.microsoftonline.com/${azureTenantId}`,
      redirectUri: `${azureRedirectUrl}/login/oauth2/code/`,
      navigateToLoginRequestUrl: false
    },
    cache: {
      cacheLocation: "sessionStorage",
      storeAuthStateInCookie: false
    }
  };
};
exports.msalConfig = msalConfig;
const loginRequestNoPrompt = exports.loginRequestNoPrompt = {
  scopes: ["User.Read"],
  prompt: 'none'
};
const loginRequestDefault = exports.loginRequestDefault = {
  scopes: ["User.Read"],
  prompt: 'select_account'
};
//# sourceMappingURL=MsalClientConfig.js.map